import React from "react";
import Img from "gatsby-image";

import cloud_texture from "./../../images/mb/cloud_texture.png";

const HalfScreenParallaxHero = ({ title, bg, symbol }) => {
  return (
    <div>
      <section
        className="page-title parallax13 parallax-fix page-title-large"
        style={{
          background: `url(${bg}) 50% 0px`,
          height: "50vh"
        }}
      >
        <div className="titleContainer">
          <div className="animated fadeInUp">
            {/* page title (large screen) */}
            <div className="separator-line bg-yellow no-margin-top margin-five" />
            <h1 className="white-text">{title}</h1>
            {/* end page title (large screen) */}
          </div>
        </div>
      </section>

      {/* Texture and symbol */}
      <div className="no-margin-top content-section">
        <div className="extra-texture">
          <img src={cloud_texture} style={{ width: "100%" }} />
          <img className="symbol" src={symbol} />
        </div>
      </div>
      {/* End Texture and symbol */}
      <div className="text-center heading no-padding overflow-hidden">
        {/* Page Title (small screen) */}
        <h1 className="white-text">{title}</h1>
        {/* END Page Title (small screen) */}
      </div>
    </div>
  );
};

export default HalfScreenParallaxHero;

export const HeaderBG = graphql`
  fragment HeaderBG on ImageSharp {
    resolutions(width: 1920, toFormat: JPG, quality: 90) {
      src
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/HalfScreenParallaxHero/index.js